import { render, staticRenderFns } from "./UnbornReasonsModal.vue?vue&type=template&id=0664e5f8&scoped=true"
import script from "./UnbornReasonsModal.vue?vue&type=script&lang=js"
export * from "./UnbornReasonsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664e5f8",
  null
  
)

export default component.exports